import { AuditLog } from 'types/audit-log';
import { Database } from 'database';
import { dateToTicks } from 'helpers/date-helper';
import { NmvsActionType } from 'types/nmvs-action-type';
import { OperationItem } from 'types/operation-item';

export function migratoToVersion7(context: Database, db: IDBDatabase, indexNames: string[], transaction: IDBTransaction) {
    if (db.objectStoreNames.contains(indexNames[7])) {
        const me = context;
        context.readAll(context.config.indexes.AuditLog, transaction)
            .then(auditLogs => {
                auditLogs.forEach((auditLog: AuditLog) => {
                    auditLog.timestamp = dateToTicks(new Date(auditLog.timestamp));
                    me.put(me.config.indexes.AuditLog, auditLog, auditLog.id.toString(), transaction).catch();
                });
            });

        migrateOperationItems(me, transaction, me.config.indexes.Complete);
        migrateOperationItems(me, transaction, me.config.indexes.Pending);
    }
}

function migrateOperationItems(context: Database, transaction: IDBTransaction, tableName: string) {
    context.readAll(tableName, transaction)
      .then(completes => {
        completes.forEach((complete: OperationItem) => {
          // tslint:disable-next-line:no-any
          switch (complete.operation as any) {
            case 'Verify':
              complete.operation = NmvsActionType.Verify;
              break;

            case 'Sample':
              complete.operation = NmvsActionType.Sample;
              break;

            case 'Dispense':
              complete.operation = NmvsActionType.Dispense;
              break;

            case 'UndoDispense':
              complete.operation = NmvsActionType.UndoDispense;
              break;

            case 'UndoSample':
              complete.operation = NmvsActionType.UndoSample;
              break;

            case 'Destroy':
              complete.operation = NmvsActionType.Destroy;
              break;

            default:
          }

          context.put(tableName, complete, complete.clientTransactionId.toString(), transaction).catch();
        });
      });
  }


// WEBPACK FOOTER //
// ./src/migrations/1.3-to-1.4.ts